// extracted by mini-css-extract-plugin
export default {"button":"styles_button__wOw31","modalContainer":"styles_modalContainer__-CsMr","modal":"styles_modal__09W6t","header":"styles_header__gldxK"};